

export const OrderTransName = {
  SavedOrderDetailScheduling: 'Saved Order Detail Scheduling',
  NewOrder: 'New Order',
  TimeBooking: 'Time Booking '
}
//---------------------
export const ServiceTypeTags = [
  { serial: 6604, type: 1, tagName: 'LABORATORY' },
  { serial: 6607, type: 2, tagName: 'RADIOLOGY' },
  { serial: 6621, type: 4, tagName: 'PHYSICALTHERAPY' }, /////////
  { serial: 6608, type: 7, tagName: 'DIALYSIS' },
  { serial: 6609, type: 13, tagName: 'SURGERY' },
  { serial: 6610, type: 14, tagName: 'CATHETER' },
  { serial: 6611, type: 15, tagName: 'ENDOSCOPY' },
  { serial: 6612, type: 16, tagName: 'EMERGENCY' },
  { serial: 6613, type: 20, tagName: 'OPERATIONSERVICE' },
  { serial: 6614, type: 21, tagName: 'THERAPEUTICFEEDINGOBESITY' },
  { serial: 6615, type: 22, tagName: 'DERMATOLOGYCOSMETICLASER' },
  { serial: 6617, type: 24, tagName: 'Dental' },
  { serial: 6618, type: 26, tagName: 'COMMUINCATION' },
  { serial: 6616, type: 17, tagName: 'ANYORDER' },
]
//---------------------------------------------
//---------------------------------------------

// export const ServiceTypeTags2 = [s
//   { serial: 6616, type: 1, tagName: 'RESERVATIONORDER' },
//   { serial: 6617, type: 2, tagName: 'TRANSFERORDER' },
//   { serial: 6618, type: 4, tagName: 'TRANSFERBEDORDER' }, /////////
//   { serial: 6619, type: 7, tagName: 'Bloodorder' },
// ]
//------------------------------------------------
//SavedOrderDetailScheduling  Action Constants
export const ADD_IFNOT_EXIST = 'ADD_IFNOT_EXIST';
export const REMOVE_SERVICE = 'REMOVE_SERVICE';
export const SET_RESOURCE = 'SET_RESOURCE';
export const REMOVE_RESOURCE = 'REMOVE_RESOURCE';
export const SET_TIME = 'SET_TIME';
export const REMOVE_TIME = 'REMOVE_TIME';
export const SET_CURRENT = 'SET_CURRENT';
export const GET_CURRENT = 'GET_CURRENT';
export const CLEAR_ALL = 'CLEAR_ALL';

// Filter Constants
export const THE_CURRENT = 'THE_CURRENT';
export const HAVE_TIME = 'HAVE_TIME';




const scheduleDetail = (state, action) => {
  switch (action.type) {
    case SET_RESOURCE:
      if (state.currentServ) {
        return Object.assign({}, state, action.payload);
      }
      return state;
    case REMOVE_RESOURCE:
      if (state.currentServ) {
        return Object.assign({}, state, action.payload);
      }
      return state;
    case SET_TIME:
      if (state.currentServ) {
        return Object.assign({}, state, action.payload);
      }
      return state;
    case REMOVE_TIME:
      if (state.currentServ) {
        return Object.assign({}, state, action.payload);
      }
      return state;

    case SET_CURRENT:
      if (state.serial === action.payload) {
        return Object.assign({}, state, { currentServ: true });
      } else
        return Object.assign({}, state, { currentServ: false });

    default:
      return state;
  }
}
export const checkExist = (state, action) => {
  return state
    .filter(service => service.serial == action.payload['serial']).length == 0 ? false : true;
}

//remember to avoid mutation within reducers
export const RegPatServiceReducer = (state = [], action) => {
  switch (action.type) {
    case CLEAR_ALL:
      return action.payload;

    case ADD_IFNOT_EXIST:
      if (!checkExist(state, action))
        return [
          ...state,
          Object.assign({}, action.payload, { currentServ: true })
        ];

      return state;
    case REMOVE_SERVICE:
      return state
        .filter(service => service.serial !== action.payload);
    //to shorten our case statements, delegate detail updates to second private reducer   
    case SET_RESOURCE:
      return state.map(service => scheduleDetail(service, action));
    case REMOVE_RESOURCE:
      return state.map(service => scheduleDetail(service, action));
    case SET_TIME:
      return state.map(service => scheduleDetail(service, action));
    case REMOVE_TIME:
      return state.map(service => scheduleDetail(service, action));
    case SET_CURRENT:
      return state.map(service => scheduleDetail(service, action));
    case GET_CURRENT:
      return state
        .filter(service => service.currentServ == true);
    //always have default return of previous state when action is not relevant   
    default:
      return state;
  }
}
